import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SafeHtmlPipe } from 'src/app/templates/safe.pipe';
import { ContentService } from '../../../services/content.service';

@Component({
  selector: 'app-team-profile-blind-spots',
  templateUrl: './team-profile-blind-spots.component.html',
  styleUrls: ['./team-profile-blind-spots.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, SafeHtmlPipe],
})
export class TeamProfileBlindSpotsComponent implements OnInit {
  @Input() mbtiType: string;
  isApiDataLoaded: boolean = false;
  reportContent: string;

  constructor(private contentService: ContentService) {}

  ngOnInit() {
    this.contentService.getReport('TeamsTeamBlindSpots', this.mbtiType).subscribe((data) => {
      this.reportContent = data.content;
      this.isApiDataLoaded = true;
    });
  }
}
